import { showOtherConnectionsAttribute } from '../constants';
import { BowtieLayout } from '../types';

export const mapIncludeConnectedCases = (layoutData: BowtieLayout): boolean => {
  const optionShowOtherConnections = layoutData && layoutData.layoutTypeAttributes
    && layoutData.layoutTypeAttributes[showOtherConnectionsAttribute];

  return optionShowOtherConnections &&
    optionShowOtherConnections.toString().toLowerCase() === 'true' || false;
};
